/* eslint-disable */
// Override Settings
var bcSfSearchSettings = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function (suggestionElement, searchElement, searchBoxId) {
};

function closeSuggestionMobile(searchBoxId, isCloseSearchBox) {
  jQ(searchBoxId).autocomplete('close');
  jQ('.' + bcsffilter.class.searchSuggestion + '[data-search-box="' + searchBoxId + '"]').parent().hide();
  // Remove search box
  var isCloseSearchBox = typeof isCloseSearchBox !== 'undefined' ? isCloseSearchBox : false;
  if (isCloseSearchBox) jQ('.bc-sf-search-suggestion-mobile-top-panel').hide();
  // Update current term for all search boxes
  setValueAllSearchBoxes();
  // Add back tabindex=-1
  jQ('.bc-sf-search-no-tabindex').attr('tabindex', -1);
  // Return scrolling of body
  jQ('body').removeClass('bc-sf-search-suggestion-mobile-open');
  if (jQ('html').hasClass('js-search-active')) {
    jQ('html').removeClass('js-search-active');
    jQ('.site-header__icon--search').removeClass('is-active');
    jQ('.site-header__search').removeClass('is-active');
  }
  bcsffilter.afterCloseSuggestionMobile(searchBoxId, isCloseSearchBox);
}